export const noFooterPages = ['/login', '/404', '/403', '/resetpassword'];
export const noHeaderPages = ['/login', '/404', '/403', '/resetpassword'];
export const noSideBarPages = ['/login', '/404', '/403', '/resetpassword'];
export const classNameContent = [
  { page: '/login', class: 'p-0' },
  { page: '/resetpassword', class: 'p-0' },
];
